import React, { useEffect, useMemo, useState } from "react";
import "./ColumnsConfigModal.css";

/** Ten sam zestaw kluczy i domyślna widoczność co w OrdersPage */
const defaultConfig = {
  nr_ref: true,
  tytul: true,
  osoba_wprowadzajaca_id: true,
  osoba_wykonujaca_id: true,
  rodzaj_zgloszenia: true,
  obszar_id: false,
  klient_id: false,
  osoba_zlecajaca: false,
  data_zlecenia: true,
  status: true,
  data_przyjecia: false,
  data_zakonczenia: true,
  data_zamkniecia: false,
  osoba_walidujaca_id: false,
  osoba_zamykajaca_id: false,
  waga: true,
  godziny: false,
  material: false,
};

/** Przyjazne etykiety do wyświetlenia użytkownikowi */
const LABELS = {
  nr_ref: "Numer Zlecenia",
  tytul: "Tytuł",
  osoba_wprowadzajaca_id: "Zgłaszający",
  osoba_wykonujaca_id: "Przydzielony",
  rodzaj_zgloszenia: "Rodzaj",
  obszar_id: "Obszar",
  klient_id: "Klient",
  osoba_zlecajaca: "Osoba Zlecająca",
  data_zlecenia: "Data Utworzenia Zlecenia",
  status: "Status Zlecenia",
  data_przyjecia: "Data Przyjęcia",
  data_zakonczenia: "Data Zakończenia",
  data_zamkniecia: "Data Zamknięcia",
  osoba_walidujaca_id: "Osoba Walidująca",
  osoba_zamykajaca_id: "Osoba Zamykająca",
  waga: "Priorytet",
  godziny: "Godziny",
  material: "Materiał",
};

function ColumnsConfigModal({
  initialConfig,
  onSavePermanent,
  onSaveTemporary,
  onCancel,
}) {
  const [config, setConfig] = useState(initialConfig || defaultConfig);
  const [query, setQuery] = useState("");

  useEffect(() => {
    setConfig(initialConfig || defaultConfig);
  }, [initialConfig]);

  // Zamknij ESC
  useEffect(() => {
    const handler = (e) => {
      if (e.key === "Escape") onCancel();
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [onCancel]);

  const keys = useMemo(() => Object.keys(defaultConfig), []);
  const filteredKeys = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return keys;
    return keys.filter((k) =>
      (LABELS[k] || k).toLowerCase().includes(q)
    );
  }, [keys, query]);

  const selectedCount = useMemo(
    () => keys.reduce((sum, k) => sum + (config[k] ? 1 : 0), 0),
    [config, keys]
  );

  const handleToggle = (name) => {
    setConfig((prev) => ({ ...prev, [name]: !prev[name] }));
  };

  const setAll = (value) => {
    const next = { ...config };
    keys.forEach((k) => {
      next[k] = value;
    });
    setConfig(next);
  };

  const handleRestoreDefaults = () => {
    setConfig(defaultConfig);
  };

  const handleSavePermanent = () => onSavePermanent(config);
  const handleSaveTemporary = () => onSaveTemporary(config);

  return (
    <div className="ccm-overlay" role="dialog" aria-modal="true">
      <div className="ccm-modal">
        <div className="ccm-header">
          <h3 className="ccm-title">Widoczność kolumn</h3>
          <p className="ccm-subtitle">
            Zaznacz, które kolumny pokazywać w tabeli zleceń.
          </p>
        </div>

        <div className="ccm-toolbar">
          <div className="ccm-search">
            <input
              type="text"
              placeholder="Szukaj kolumny…"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              aria-label="Szukaj kolumny"
            />
            <span className="ccm-search-count">
              {selectedCount}/{keys.length} wybrane
            </span>
          </div>
          <div className="ccm-quick">
            <button className="ccm-btn ghost" onClick={() => setAll(true)}>
              Zaznacz wszystko
            </button>
            <button className="ccm-btn ghost" onClick={() => setAll(false)}>
              Odznacz wszystkie
            </button>
            <button className="ccm-btn ghost" onClick={handleRestoreDefaults}>
              Przywróć domyślne
            </button>
          </div>
        </div>

        <div className="ccm-grid">
          {filteredKeys.map((field) => (
            <label
              key={field}
              className={`ccm-chip ${config[field] ? "active" : ""}`}
              htmlFor={`toggle-${field}`}
              title={LABELS[field] || field}
            >
              <input
                id={`toggle-${field}`}
                type="checkbox"
                checked={!!config[field]}
                onChange={() => handleToggle(field)}
              />
              <span className="ccm-chip-label">{LABELS[field] || field}</span>
              <span className="ccm-chip-switch" aria-hidden />
            </label>
          ))}
          {filteredKeys.length === 0 && (
            <div className="ccm-empty">Brak wyników dla “{query}”.</div>
          )}
        </div>

        <div className="ccm-footer">
          <button className="ccm-btn secondary" onClick={handleSaveTemporary}>
            Zapisz (tylko teraz)
          </button>
          <button className="ccm-btn primary" onClick={handleSavePermanent}>
            Zapisz i zapamiętaj
          </button>
          <button className="ccm-btn flat" onClick={onCancel}>
            Anuluj
          </button>
        </div>
      </div>
    </div>
  );
}

export default ColumnsConfigModal;
